/**
 * Authentication and Authorisation Service API
 * This is the auth-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserDto { 
    customerId?: number;
    displayName?: string;
    fullNames?: string;
    lastName?: string;
    email?: string;
    passwd?: string;
    employmentRoles?: Set<string>;
    roles?: Set<string>;
}

